import api from '../../../api';
import { finish, error } from '../../../modules/staff/actions/update';

export function request(dispatch, { id, data }) {
    api.patch(`/staff/${id}`, data).then(
        user => dispatch(finish(id, user)),
        ({ errors }) => dispatch(error(id , errors))
    );
}
